import React from "react";

import { useNavigate } from "react-router-dom";

import ICONS from "../../../assets/Icons";
import LargePopupRedirect from "../CommonPopups/CommonLargePopupRedirect";
import FieldForceAccountDetails from "../../../containers/FieldForceAccount/FieldForceAccountDetails";

function FieldForceAccountDetailsPopup({
  closeBeneAccountDetailModal,
  type = "field_force_account_detail_modal",
  field_force_account_id,
}) {
  const navigate = useNavigate();

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <LargePopupRedirect
        headerTitle="Field force account details"
        headerFontWeight="semibold"
        headerFontColor="text-primary"
        smallPopupHeader={"Are you sure you want to leave this page?"}
        headertextSize="font-md"
        isfullViewrequired={true}
        fullviewbtnText="Open in full view"
        fullviewbtnType="button"
        fullviewhandleFunction={() => {
          closeBeneAccountDetailModal();
          navigate(
            `/field_force_account_dashboard/field_force_account_view_all/field_force_account_detail_page/${field_force_account_id}`,
          );
        }}
        fullviewisDisabled={false}
        fullviewenabledTextColor="var(--text-primary)"
        fullviewenabledBgColor="var(--primary-nav)"
        fullviewhoverOption="white"
        fullviewicon={ICONS?.REDIRECT}
        fullviewdisabledBgColor="var(--text-disabled)"
        closeiconbtnType="button"
        closeiconhandleFunction={closeBeneAccountDetailModal}
        closeiconisDisabled={false}
        closeiconenabledBgColor="var(--primary-nav)"
        closeicondisabledBgColor="var(--text-disabled)"
        closeiconhoverOption="white"
        closeicon={ICONS?.CLOSE}
        isbottomSectionneed={false}
        bottomHeaderTextNeed={false}
        isscrollRequired={true}
      >
        <FieldForceAccountDetails
          bene_account_id={field_force_account_id}
          type={"field_force_account_detail_modal"}
          closeBeneAccountDetailModal={closeBeneAccountDetailModal}
        />
      </LargePopupRedirect>
    </div>
  );
}

export default FieldForceAccountDetailsPopup;
